var map = {
	"./video-carousel.de-CH.json": 1560,
	"./video-carousel.de-DE.json": 1561,
	"./video-carousel.en-CA.json": 1562,
	"./video-carousel.en-GB.json": 1563,
	"./video-carousel.en-IN.json": 1564,
	"./video-carousel.en-ME.json": 1565,
	"./video-carousel.en-US.json": 1566,
	"./video-carousel.es-EM.json": 1567,
	"./video-carousel.es-ES.json": 1568,
	"./video-carousel.fr-BE.json": 1569,
	"./video-carousel.fr-CA.json": 1570,
	"./video-carousel.fr-CH.json": 1571,
	"./video-carousel.nl-BE.json": 1572,
	"./video-carousel.nl-NL.json": 1573,
	"./video-carousel.pl-PL.json": 1574,
	"./video-carousel.pt-BR.json": 1575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1559;